import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8d4977c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "white-card" }
const _hoisted_2 = { class: "white-card__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "white-card__title" }, "Модифицированный индекс кровоточивости", -1))
const _hoisted_4 = { class: "white-card__content" }
const _hoisted_5 = { class: "white-card__footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
const _hoisted_8 = {
  key: 2,
  class: "white-card__sign"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "white-card__paragraph white-card__red"
}
const _hoisted_11 = {
  key: 1,
  class: "white-card__paragraph white-card__yellow"
}
const _hoisted_12 = {
  key: 2,
  class: "white-card__paragraph white-card__green"
}

import { computed, ref } from 'vue'
import IndexBloodingModalWindow from '@/pages/ScreeningPage/components/IndexBloodingModalWindow.vue'
import IndexBloodingTable from '@/pages/ScreeningPage/components/IndexBloodingTable.vue'
import { useRoute } from 'vue-router'
import IconTemplate from '@/apps/components/IconTemplate.vue'
import { ScreeningControllerInterface } from '@/pages/ScreeningPage/screeningController'

interface Props {
  screeningController: ScreeningControllerInterface
}


export default /*#__PURE__*/_defineComponent({
  props: {
    screeningController: null
  },
  emits: ['saveReport', 'updateReport'],
  setup(__props: any) {




const route = useRoute()
const isCreationPage = computed(() => route.params.reportId === '0')
const isModalVisible = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isModalVisible.value = true))
        }, [
          _createVNode(IconTemplate, {
            height: "22",
            name: "tip",
            width: "22"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(IndexBloodingTable, { "screening-controller": __props.screeningController }, null, 8, ["screening-controller"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!_unref(isCreationPage))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              disabled: !__props.screeningController.isUpdatedModifiedBleedingIndex(),
              class: "el-button--screening",
              round: "",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateReport')))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["disabled"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "el-button--screening",
              round: "",
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('saveReport')))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })),
        (!_unref(isCreationPage))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass([{
            'white-card__red':
              __props.screeningController.modifiedBleedingIndexValue > 25,
            'white-card__yellow':
              __props.screeningController.modifiedBleedingIndexValue >= 10 &&
              __props.screeningController.modifiedBleedingIndexValue <= 25,
            'white-card__green':
              __props.screeningController.modifiedBleedingIndexValue <= 9,
          }, "white-card__percent"])
              }, _toDisplayString(__props.screeningController.modifiedBleedingIndexValue) + "% ", 3),
              (__props.screeningController.cpitnValue.includes('3'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (__props.screeningController.modifiedBleedingIndexValue > 25)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Генерализованный гингивит "))
                      : (__props.screeningController.modifiedBleedingIndexValue >= 10)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Локализованный гингивит "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, " Клинически здоровая десна "))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(IndexBloodingModalWindow, {
      "is-modal-visible": isModalVisible.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (isModalVisible.value = false))
    }, null, 8, ["is-modal-visible"])
  ], 64))
}
}

})